export default "__VITE_ASSET__55fb3043__"